export default __webpack_public_path__ + "static/media/homebotNotification.bdaa60dd.svg";